/* eslint-disable react-hooks/exhaustive-deps */
import { useRef} from "react";
import { useReactToPrint } from "react-to-print";
import PrintIcon from '@material-ui/icons/Print';

import {
	Col,
	Nav,
	Collapse,
	ButtonGroup,
	Button,
	Dropdown,
} from "react-bootstrap";
import {useState, useEffect} from "react";
import Tree from "../components/TreeAll";
import IdProyect from "./IdProyect";
import {Resizable} from "re-resizable";
import "../styles/project.css";
import {useSelector, useDispatch} from "react-redux";
import IdPc from "./IdPc";
import {useHistory} from "react-router-dom";
import {pcHeader, treeDe, treeFt, treePc, ClassificationResource, treeProject, getProyectDates} from "../actions/proyects.actions";


//Routes
import {PrivateRoute} from "../routes/PrivateRoutes";
import TreeClassification from "../components/TreeClassification";
import TreeMeans from "../components/TreeMeans";
import IdMeans from "./IdMeans";
import { getUserPreferences } from "../services/apiPreferences";
import { SelectedDateFn, selectedScaleFn, setLoadingPreferences } from "../actions/auth.action";

const Proyects = (props) => {
	const dispatch = useDispatch();
	const proyects = useSelector((state) => state.proyects);
	const auth = useSelector(state => state.auth);
	const [width, setWidth] = useState(400);
	const [height, setHeight] = useState(200);
	const [tree, setTree] = useState(false);
	const [level, setLevel] = useState(1);
	const [open, setOpen] = useState(true);
	const [secondTabData, setSecondTabData] = useState([]);
	const [secondTabUrlLabel, setSecondTabUrlLabel] = useState('pc');
	const history = useHistory();
	const codProUrl = props.location.pathname.split("/")[2];
	const codClaUrl = props.location.pathname.split("/")[4];
	const codTypeUrl = props.location.pathname.split("/")[3];
	const codMeUrl = props.location.pathname.split("/")[6];
	const [type, setType] = useState("01");
	// const classificationUrl = props.location.pathname;
	// console.log(classificationUrl, '<--- proyects.js');
	const setClassificationData = (pType = '01') => {
		
		if ( codProUrl ) {
			// TODO: llamar a cada uno de los elementos solo si el proyecto tiene la opcion en la pestaña
			
			setSecondTabData([])
			if (proyects.treePartyControl.length === 0) {
				dispatch(treePc(codProUrl, type));
			}
			if (proyects.treeFT.length === 0) {
				dispatch(treeFt(codProUrl, type));
			}
			if (proyects.treeDE.length === 0) {
				dispatch(treeDe(codProUrl, type));
			}
			if ( codClaUrl && proyects.classicationData.length === 0) {
				
				dispatch(ClassificationResource(codProUrl, pType, codClaUrl));
			}
			if ( pType === '01' ) {
				setSecondTabUrlLabel('pc');
				setSecondTabData(proyects.treePartyControl);
			}
			if ( pType === '04' ) {
				setSecondTabUrlLabel('fr');
				setSecondTabData(proyects.treeFT);
			}
			if ( pType === '05' ) {
				setSecondTabUrlLabel('de');
				setSecondTabData(proyects.treeDE);
			}
		}
	}

	useEffect(() => {
		dispatch(treeProject())
		dispatch(setLoadingPreferences(true))
		getUserPreferences()
			.then(({data}) => {
				console.log('---- data', data)
				if (data.dateSelected !== undefined) dispatch(SelectedDateFn(data.dateSelected))
				dispatch(selectedScaleFn(data?.scaleSelected || '0'))
			}).catch(e => console.error(e))
			.finally(() => {
				dispatch(setLoadingPreferences(false))
			});
	}, []);

	useEffect(() => {
		setSecondTabData([])
		if ( !codProUrl || auth.loadingPreferences) return;
		
		setClassificationData(type);
		if (codMeUrl) {
			setTree("means");
			return setLevel(null);
		}
		if (codProUrl && codClaUrl) {
			setTree("classi");
			setLevel(null);
		} 
		else {
			setLevel(1);
			// setTree(0);
		}
		// eslint-disable-next-line
	}, [codProUrl, type, auth.loadingPreferences]);

	useEffect(() => {
		if (auth.loadingPreferences) {
			return;
		}
		setSecondTabData(proyects.treePartyControl);
		// eslint-disable-next-line
	}, [ proyects.treePartyControl, auth.loadingPreferences])
	
	// get dates
	useEffect(() => {
		if (auth.loadingPreferences) {
			return;
		}
		dispatch(getProyectDates(codProUrl, auth.scaleSelected));
		// eslint-disable-next-line
	}, [auth.scaleSelected, auth.loadingPreferences, codProUrl]);

	// set date by default
	useEffect(() => {
		if (auth.loadingPreferences || proyects.dates.length === 0 || (auth.dateSelected && proyects.dates.find(d => d.CodPeriodo === auth.dateSelected))) {
			return;
		}
		dispatch(SelectedDateFn(proyects.dates[0].CodPeriodo))
		// eslint-disable-next-line
	}, [proyects.dates, auth.dateSelected]);

	const ClassificationDropdownItem = (typeValue, title) => {
		return (
			<Dropdown.Item
				className="test"
				active={false}
				onClick={() => {
					// console.log(proyects.treePartyControl);
					// setSecondTabData(proyects.treePartyControl)
					setType(typeValue);
					setClassificationData(typeValue);
					dispatch(pcHeader(true));
				}}
			>
				{title}
			</Dropdown.Item>
		);
	}
	
	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});
	if (codProUrl && (auth.loadingPreferences || (proyects.dates.length > 0 && !auth.dateSelected))) {
		return "cargando..."
	}

	return (
		<div className="d-flex flex-wrap justify-content-between overflow-hidden h-100">
			<Resizable
				className="tree-fixed p-0 d-flex h-100 justify-content-between"
				size={{width: width}}
				maxHeight="95vh"
				maxWidth={open ? "30vw" : 0}
				minHeight="95vh"
				minWidth={open ? "20vw" : 0}
				onResizeStop={(e, direction, ref, d) => {
					setWidth(width + d.width);
					setHeight(height + d.height);
				}}
			>
				<Collapse in={open}>
					<div className="p-2 mt-1 w-100">
						<div className="mb-2">
							<Nav
								variant="tabs"
								defaultActiveKey="/projects"
								className="eyelashes"
							>
								<Nav.Item
									onClick={() => {
										setLevel(1);
										setTree("project");
									}}
								>
									<Nav.Link
										to="#"
										active={!tree || tree === "project"}
										onClick={() => {
											if (
												proyects.urlTreeProject !== ""
											) {
												// dispatch(pcHeader(false));
												history.push(
													proyects.urlTreeProject
												);
											}
										}}
									>
										Proyecto
									</Nav.Link>
								</Nav.Item>

								<Nav.Item
									onClick={() => {
										setTree(1);
										setTree("classi");
										setClassificationData(type);
									}}
								>
									<Nav.Link
										to="#"
										eventKey="link-1"
										active={tree === "classi"}
										onClick={() => {
											if (proyects.urlTreePc !== '') {
												history.push(proyects.urlTreePc)
											}
										}}
									>
										<Dropdown as={ButtonGroup} >
											{secondTabUrlLabel.toUpperCase()}
											{/* <Button className="btn-nav">
											</Button> */}

											<Dropdown.Toggle
												split
												id="dropdown-split-basic"
											/>

											<Dropdown.Menu>
												{proyects.projectDetails && proyects.projectDetails[0] && (
													<>
														{/* PC */}
														{/* {proyects.projectsDetails} */}
														{proyects
															.projectDetails[0]
															.ExistePC && (
																ClassificationDropdownItem("01","PC Partida de Control")
														)}
														{/* DE */}
														{proyects
															.projectDetails[0]
															.ExisteDE && (
																ClassificationDropdownItem("05","DE Destino Específico")
														)}
														{/* FR */}

														{proyects
															.projectDetails[0]
															.ExisteFR && (
																ClassificationDropdownItem("04","FR Frente")
														)}
													</>
												)}
											</Dropdown.Menu>
										</Dropdown>
									</Nav.Link>
								</Nav.Item>

								<Nav.Item
									onClick={() => {
										setTree("means");
									}}
								>
									<Nav.Link
										to="#"
										eventKey="link-3"
										active={tree === "means"}
										onClick={() => {
											// dispatch(pcHeader(true))
											if (proyects.urlTreeMeans !== '') {
												history.push(proyects.urlTreeMeans)
											}
										}}
									>
										Recursos
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<div style={{paddingLeft: 5}}>
										<Button onClick={handlePrint}><PrintIcon/></Button>
									</div>
								</Nav.Item>
							</Nav>
						</div>

						<div
							className="mt-2 p-2 overflow-auto"
							style={{height: "80vh"}}
						>
							{tree === "classi" && (
								<TreeClassification
									// levelStart={1}
									idProject={codProUrl}
									type={type}
									codCla={ codClaUrl }
									data={ secondTabData }
									// urlLabel={ secondTabUrlLabel }
									urlPrefix={`/projects/${codProUrl}/${secondTabUrlLabel}/`}
								/>
							)}

							{(!tree || tree === "project") && (
								<Tree
									levelStart={level}
									nodeSelected={codProUrl}
								/>
							)}
							{tree === "means" && <TreeMeans
								idProject={codProUrl}
								type={codTypeUrl}  
								idClassification={codClaUrl}
								idMeans={codMeUrl}
								data={proyects.classicationData}
								urlPrefix={`/projects/${codProUrl}/${codTypeUrl}/${codClaUrl}/means/`}
							/>}
						</div>
					</div>
				</Collapse>
				<div
					className="bara-cerrar potencia d-flex align-items-center"
					style={{
						width: 12,
						height: "100%",
						background: "#dee2e6",
					}}
				>
					<div
						style={{cursor: "pointer"}}
						className="h-25 w-100 bg-primary d-flex align-items-center"
						onClick={() => {
							setOpen(!open);
						}}
						aria-controls="example-collapse-text"
						aria-expanded={open}
					>
						{open ? (
							<ion-icon name="caret-back-outline"></ion-icon>
						) : (
							<ion-icon name="caret-forward-outline"></ion-icon>
						)}
					</div>
				</div>
			</Resizable>

			<Col className="bigs-data px-4 w-100">
				<div className="page-break" ref={componentRef}>
					<h4 className="project-title">
						{proyects.titleProject && proyects.titleProject.split(' / ')[1] + ' - ' + proyects.titleProject.split(' / ')[2]}
					</h4>
					<PrivateRoute
						path="/projects/:codProject"
						component={IdProyect}
						codType={'01'}
						exact
					/>
					<PrivateRoute
						path="/projects/:codProject/:codClassification/:codPc"
						component={IdPc}
						// type={type}
						exact
					/>
					<PrivateRoute
						path="/projects/:codProject/:codClassification/:codPc/means/:codMeans"
						component={IdMeans}
						// type={type}
						exact
					/>
				</div>
				
			</Col>
		</div>
	);
};

export default Proyects;
